<template>
  <div class="cmp-distribution-accounts-accounts_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddAccountClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <Dropdown
          style="margin: 0 20px; width: 150px"
          :options="accountTypes"
          :selected="selectedAccountTypes"
          :placeholder="$t(`account_type`)"
          :title="$t(`account_type`)"
          multiple
          allnone
          borderbottom
          v-on:selectedChange="(e) => onAccounTypeList(e)"
          :listHeight="252"
        ></Dropdown>
        <Dropdown
          :options="channelTV"
          style="margin-top: -1px; min-width: 150px"
          :placeholder="$t(`channel`)"
          deselect
          borderbottom
          :selected="channelTV.find((e) => e.value == basicFilter.channel)"
          v-on:selectedChange="(e) => onDropdownChange('channel', e)"
        >
        </Dropdown>
      </div>
    </div>
    <div class="dt-page--body" :style="{ '--offset': '120px' }">
      <!-- @scrollnext="onListScroll" -->
      <NTable
        class="h1"
        :id="'distribution-accounts-account_list'"
        :headers="headers"
        :config="tableConfig"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            :class="{
              selected: selectedRow(item),
            }"
            @click="onAccountClicked(item)"
          >
            <td v-bind="tdcon('account_name')">
              <div class="ut-flex">
                <DtStatus
                  :statusTVList="statusTV"
                  :item="getItemForStatus(item)"
                  @updateStatus="onStatusChange"
                />
                <span>{{ item["account_name"] }}</span>
              </div>
            </td>
            <td v-bind="tdcon('shortname')">
              <span>{{ item["short_name"] }}</span>
            </td>
            <td v-bind="tdcon('account_type')" :class="['account_type']">
              <span>{{ item["account_type"] }}</span>
            </td>
            <td v-bind="tdcon('staff_org')">
              <span>{{ item["user_name"] }}</span>
            </td>
            <td v-bind="tdcon('digital')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="'digital'"
                    :id="'digital'"
                    :checked="item['digital'] == '1'"
                    @click.stop="(e) => onCheckboxChange(e, 'digital', item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('physical')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="'physical'"
                    :id="'physical'"
                    :checked="item['physical'] == '1'"
                    @click.stop="(e) => onCheckboxChange(e, 'physical', item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <div class="option-buttons">
                <div class="dt-icon-container">
                  <img
                    src="static/icons/delete.svg"
                    @click.stop="(e) => onAccountDelete(item)"
                    class="dt-icon v5 s2"
                    alt="Delete account"
                    title="Delete account"
                  />
                </div>
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <DtPageStatusFloat :statusTV="statusTV" />
    <Sidewindow
      :navConfig="defaultConfig"
      :value="accountDetailsFlag"
      @closed="onCloseAccountDetails"
    >
      <AccountSidewindow />
    </Sidewindow>
    <ModalContainer :modalKey="'newAccount'" :width="'small'">
      <NewAccount
        :accountTypes="accountTypes"
        @cancelled="onDialogCancelled"
        @added="onAdded"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'newCurrentStatement'" :width="'small'">
      <AddCurrentStatement
        @cancelled="onDialogCancelled"
        @added="onInsertCurrentStatements"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'importSetupModal'" :width="modalSize">
      <ImportSetupModal
        @setModalSize="setModalSize"
        @insert="onInsertImportSetup"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>

    <ModalContainer :modalKey="'performModal'" :width="'small'">
      <PeformModal @cancelled="onDialogCancelled" />
    </ModalContainer>
  </div>
</template>

<script>
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import InputField from "@plugins/text-field/input-field";
import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { DistributionStoreNamespace as storeNS } from "../../store";
import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  getDistributionAccountDetailsSelectable,
  distributionAccountListLDTRoutes,
} from "../../router/routes";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import NewAccount from "./add-accounts.vue";
import { distributionAccountActions } from "../../store/accounts/actions";
import { distributionAccountGetters } from "../../store/accounts/getters";
import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { AccountService } from "../../services/account.service";
import { DTIconButton } from "../../../../plugins/button/button";
import { createTV, createTVI } from "../../../../models/text-value.model";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import DtStatus from "@dtplugins/dt-status-dropdown/dt-status";

import AccountSidewindow from "./account-sidewindow.vue";

import AddCurrentStatement from "./add-current-statement";

import ImportSetupModal from "./import-setup-modal.vue";

import PeformModal from "./perform-modal.vue";
import { confirmDelete } from "@/dt-plugins/confirmation/confirmation-common";

const LDTConfig = {
  entityName: "account",
  ldtRoutes: distributionAccountListLDTRoutes,
  detailsSelectableFunction: getDistributionAccountDetailsSelectable,
  primaryKey: "account_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.DistributionAccountDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.DistributionAccountDetails.FETCH.SINGLE,
};

export default {
  components: {
    ModalContainer,
    NTable,
    InputField,
    DTCheckbox,
    DTIconButton,
    AccountSidewindow,
    NewAccount,
    AddCurrentStatement,
    ImportSetupModal,
    PeformModal,
    DtPageStatusFloat,
    DtStatus,
  },
  mounted: async function () {
    const res = await AccountService.getAccountList();
    this.account_types = res.data.account_types;

    await this[ActionTypes.AccountDistributionData.FETCH.SINGLE]();
  },
  data: () => ({
    selectedAccountTypes: [],
    defaultConfig: defaultConfig,
    getDistributionAccountDetailsSelectable:
      getDistributionAccountDetailsSelectable,
    selectedClickedAccount: null,
    modalSize: "small2",
    account_types: [],
    label_statuses: [],
  }),
  mixins: [
    createLDTHost(LDTConfig),
    createFetchListMixin(ActionTypes.AccountList.FETCH.ALL, 30, {
      advancedSearchable: false,
      searchable: true,
      scrollable: true,
    }),
    createModalMixin("performModal"),
    createModalMixin("newAccount"),
    createModalMixin("newCurrentStatement"),
    createModalMixin("importSetupModal"),
  ],
  computed: {
    ...mapGetterObject(storeNS, distributionAccountGetters),

    tableConfig: () =>
      createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      }),
    list: function () {
      return this.accountList?.accounts || [];
    },
    statusTV: function () {
      return createTVI(
        this.accountDistributionData?.label_statuses,
        "label_status_name",
        "label_status_colour",
        "label_status_id"
      ) || [];
    },
    channelTV: () => [
      { text: "Digital", value: "digital" },
      { text: "Physical", value: "physical" },
    ],
    accountTypes: function () {
      return createTV(this.account_types, "account_type", "account_type");
    },

    headers: function () {
      return [
        createTableHeader("account_name", {
          fw: 700,
          text: this.$t("account"),
        }),
        createTableHeader("shortname"),
        createTableHeader("account_type"),
        createTableHeader("staff_org"),
        createTableHeader("digital", { mw: 110, ta: "center" }),
        createTableHeader("physical", { mw: 110, ta: "center" }),
        createTableHeader("options", { text: false, mw: 40 }),
      ];
    },
    accountDetailsFlag: function () {
      return childOfOrEqualDetails(
        distributionAccountListLDTRoutes,
        this.$route
      );
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionAccountActions),

    setModalSize: function (size) {
      this.modalSize = size;
    },
    // onListScroll: function (value) {
    //   console.log("OOO", this.start, this.row_count);
    //   this.scrollSubject.next(this.start);
    // },
    onDropdownChange: function (name, value) {
      this.basicFilter[name] = value.value;

      this.fetchListReset();
    },
    defaultBasicFilter() {
      return {
        searchString: undefined,
        channel: undefined,
        accountTypes: undefined,
      };
    },
    onAccounTypeList: function (value) {
      this.selectedAccountTypes = value;
      this.basicFilter.accountTypes =
        this.selectedAccountTypes && this.selectedAccountTypes.length > 0
          ? this.selectedAccountTypes.map((e) => e.value).join(",")
          : undefined;
      this.fetchListReset();
    },
    selectedRow: function (account) {
      return (
        this.selectedClickedAccount &&
        this.selectedClickedAccount.account_id === account.account_id
      );
    },
    onCheckboxChange: function (event, name, item) {
      const value = event.target.checked;
      const payload = {
        kVal: item.account_id,
        name: name,
        value: value ? 1 : 0,
      };
      this[ActionTypes.AccountList.UPDATE.SINGLE](payload);
    },
    onAddAccountClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_account",
        },
      });
    },
    refresh: function () {
      this.fetchListNext();
    },
    onAdded: function (payload) {
      this.refresh();
      this.$router.push({
        name: distributionAccountListLDTRoutes.names.tab,
        params: {
          account_id: payload.account_id,
          tab: "overview",
        },
      });
      this.onDialogCancelled();
    },
    onDialogCancelled: function () {
      this.setModalSize("small2");
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddAccountListClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_account",
        },
      });
    },

    // NEW

    onAccountDelete: async function (item) {
      const confirmationResult = await confirmDelete(
        "Account",
        item.account_name
      );
      if (confirmationResult === "OK") {
        this[ActionTypes.AccountList.DELETE.SINGLE](item);
      }
      // ConfirmationService.create({
      //   subject: "Do you really want to delete this Account?",
      //   model: true,
      //   width: 500,
      //   results: [
      //     createConfirmResult({
      //       value: "yes",
      //       text: "Yes",
      //       classes: ["v1"],
      //     }),
      //     createConfirmResult({
      //       value: "No",
      //     }),
      //   ],
      //   completed: (res) => {
      //     switch (res) {
      //       case "yes":
      //         this[ActionTypes.AccountList.DELETE.SINGLE](item);
      //         break;
      //       default: {
      //       }
      //     }
      //   },
      // });
    },

    // Start Sidewindow
    onAccountClicked: function (account) {
      console.log("account ", account);
      this.$router.push({
        name: distributionAccountListLDTRoutes.names.tab,
        params: {
          account_id: account.account_id,
          tab: "overview",
        },
      });
    },
    onCloseAccountDetails: function () {
      this.selectedClickedAccount = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: distributionAccountListLDTRoutes.names.list,
        });
      });
    },

    onInsertCurrentStatements: function (payload) {
      this[ActionTypes.DistributionAccountCurrentStatements.INSERT.SINGLE](
        payload
      );

      this.onDialogCancelled();
    },

    onInsertImportSetup: function (payload) {
      this[ActionTypes.DistributionAccountImportSetup.INSERT.SINGLE](payload);
      this.onDialogCancelled();
    },
    getItemForStatus: function (item) {
      return {
        itemID: item.account_id,
        colorPropertyName: "status_id",
        colorPropertyValue: item.status_id,
        colorName: "label_status_colour",
        colorValue: this.statusTV?.find((x) => x.id === item.status_id)?.value,
      };
    },
    onStatusChange: function (payload) {
      //const item = this.selectedReleaseDetails;
      const {
        itemID,
        colorPropertyName,
        colorName,
        colorPropertyValue,
        colorValue,
      } = payload;

      console.log({ "account-list.vue:508 payload": payload });

      const item = this.list.find((x) => x.account_id === payload.itemID);

      // this[ActionTypes.AccountList.UPDATE.SINGLE]({
      //   kVal: itemID,
      //   name: 'label_status_colour',
      //   value: colorValue,
      // });
      this[ActionTypes.AccountList.UPDATE.SINGLE]({
        kVal: itemID,
        name: "status_id",
        value: colorPropertyValue,
      });
      // this[ActionTypes.AccountList.UPDATE.SINGLE]({
      //   kVal: itemID,
      //   name: 'label_status_name',
      //   value: this.statusTV.find((x) => x.id === colorPropertyValue).text,
      // });

      // console.log(item, "payload");
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distribution-accounts-accounts_list {
  .dt-page--body {
    --offset: 190px;
  }
  .dt-page--data-table {
    --offset: 135px;
  }
  .dt-page--top-bar {
    .search {
      .dt-checkbox-control {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }
  }
}

.status {
  flex: 1;
  display: flex;
  align-items: center;
  max-width: 150px;
  .square {
    width: 15px;
    height: 15px;
    margin-right: 10px;
    border: 1px solid;
  }
}
</style>


